/*@ngInject*/
const ForwardCollaborationEmailRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.forward = function (emailId) {
        let url = '/rest/Email/' + emailId + '/forward';

        return this.post(url);
    };
};

angular.module('gw-um-submission')
    .service('forwardCollaborationEmailRepository', ForwardCollaborationEmailRepository);
